import {GameAccountDescriptionResource} from "../resource/GameAccountDescriptionResource";
import {GameAccountDescription} from "../league/GameAccountDescription";
import {IApiGameAccountDescription} from "../typings/apiResponse";
import * as angular from "angular";

export class GameAccountDescriptionService {

    public static $inject = ["GameAccountDescriptionResource"];
    constructor(private GameAccountDescriptionResource: GameAccountDescriptionResource) {}

    public getGameAccountDescription(gameAccountDescriptionType: string): angular.IPromise<GameAccountDescription> {
        return this.GameAccountDescriptionResource.getGameAccountDescription(gameAccountDescriptionType).then((apiGameAccountDescription: IApiGameAccountDescription) => {
            return new GameAccountDescription(apiGameAccountDescription);
        });
    }

    public getGameAccountDescriptions(): angular.IPromise<Array<GameAccountDescription>> {
        return this.GameAccountDescriptionResource.getGameAccountDescriptions().then((apiGameAccountDescriptions: Array<IApiGameAccountDescription>) => {
            var gameAccountDescriptions = [];

            angular.forEach(apiGameAccountDescriptions, (gameAccountDescription: IApiGameAccountDescription) => {
                gameAccountDescriptions.push(new GameAccountDescription(gameAccountDescription));
            });

            return gameAccountDescriptions;
        });
    }
}
